<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.585"
    height="13.147"
    viewBox="0 0 26.585 13.147"
  >
    <g transform="translate(-78.258 -514)">
      <g transform="translate(-1178.898 -322.013)">
        <path
          d="M1283.366,847.988H1263.9l.031-.534a52.218,52.218,0,0,1,1.236-8.671l.56.03.214-.144a4.372,4.372,0,0,0,1.045.847c.649.443,1.953-.3,2.638-.795l-.968-2.708.905.38a46.45,46.45,0,0,1,5.143,2.545,18.833,18.833,0,0,0,4.239,1.563,14.342,14.342,0,0,1,3.636,1.352c1.894,1.256.916,5.584.874,5.767Zm-18.558-1h17.9c.227-1.231.438-3.61-.548-4.264a14.113,14.113,0,0,0-3.418-1.251,19.286,19.286,0,0,1-4.418-1.639,45.882,45.882,0,0,0-4.14-2.1l.487,1.361-.281.232c-.25.2-2.474,1.989-3.832,1.059-.318-.217-.563-.4-.752-.554A51.028,51.028,0,0,0,1264.808,846.988Z"
        />
        <rect
          width="18.968"
          height="1"
          transform="translate(1264.478 844.534)"
        />
        <rect
          width="2.759"
          height="0.999"
          transform="translate(1272.024 840.962) rotate(-60.477)"
        />
        <rect
          width="2.484"
          height="1"
          transform="matrix(0.512, -0.859, 0.859, 0.512, 1273.772, 841.686)"
        />
      </g>
      <g transform="translate(13 -2.869)">
        <rect
          width="5.869"
          height="1"
          transform="translate(68.266 523.233) rotate(90)"
        />
        <path
          d="M2.326,4.89,0,2.1,2.379,0l.662.75L1.391,2.206l1.7,2.043Z"
          transform="translate(70.147 521.742) rotate(90)"
        />
        <path
          d="M.768,4.89,0,4.249,1.7,2.206.053.75.715,0,3.094,2.1Z"
          transform="translate(70.147 526.922) rotate(90)"
        />
      </g>
    </g>
  </svg>
</template>
